/**
 * SIGFU REST API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepotLigne } from './depotLigne';
import { DepotLigneAddress } from './depotLigneAddress';


export interface DepotLigneSpatialunit { 
    idSpatialunit: number;
    action?: string;
    address: DepotLigneAddress;
    allotment?: string;
    allotmentNumber?: string;
    amalgamationOf?: string;
    approvalOrder?: string;
    approvalOrderDatetime?: string;
    beginLife?: string;
    block?: string;
    cadNumber?: string;
    currentId?: string;
    description?: string;
    dimension?: string;
    endLife?: string;
    equipmentType?: string;
    gisArea?: number;
    gisAreaUnitType?: string;
    id?: string;
    idMarkupType?: string;
    idufci?: string;
    label?: string;
    ladmId?: string;
    landRegistry?: string;
    landTitle?: string;
    landUseType?: string;
    legalArea?: number;
    legalAreaApproximate?: boolean;
    legalAreaUnitType?: string;
    locality?: string;
    localiteLabel?: string;
    lot?: string;
    lotissementType?: string;
    objectOrigin?: string;
    original?: string;
    originalStatus?: string;
    otherEquipment?: string;
    place?: string;
    planNo?: string;
    protection?: string;
    protectionLevel?: string;
    protectionOwner?: string;
    registrationDatetime?: string;
    sectionNumber?: string;
    status?: string;
    statusPlan?: string;
    subdivisionOf?: string;
    suid?: string;
    surfaceRelation?: string;
    surveyArea?: number;
    surveyAreaUnitType?: string;
    surveyDate?: string;
    surveyNote?: string;
    surveyType?: string;
    suspensionType?: string;
    titleDate?: string;
    titleNo?: string;
    trCode?: string;
    trId?: string;
    trNo?: string;
    type?: string;
    uid?: string;
    version?: number;
    versionRev?: number;
    depotLigne: DepotLigne;
}

